<template>
<div>
  categories
</div>
</template>

<script>
export default {
  name: "Categories"
}
</script>

<style scoped>

</style>